const resource = {
    resource_identifier_in_use: 'API 标识符 {{indicator}} 已被使用',
    cannot_delete_management_api: '无法删除 Logto 管理 API。',
    cannot_modify_management_api: '无法修改 Logto 管理 API。',
};
export default Object.freeze(resource);
